module.exports = __webpack_public_path__ + "static/media/news2.6e7356ef.jpg";